export const NATUREZA_JURIDICA_BASE_URL =
  'https://dadosabertos.rfb.gov.br/CNPJ/dados_abertos_cnpj';

export const NATUREZA_JURIDICA_GOLDEN_LTDA = '2062';
export const NATUREZA_JURIDICA_MIN_CODES = 85;
export const NATUREZA_JURIDICA_MAX_CODES = 95;
